import { ValidationError } from "../error/taxonomy.js";
const LANGUAGE_CODE_SHAPE = /^[a-z]{2,3}(-[A-Za-z0-9]{2,8})*$/;
/** Narrows a string to a well-formed language code. Says nothing about availability. */
export function isLanguageCode(value) {
    return LANGUAGE_CODE_SHAPE.test(value);
}
/** Parses at a trust boundary. Throws rather than falling back to a reference locale. */
export function parseLanguageCode(value) {
    if (!isLanguageCode(value)) {
        throw new ValidationError({
            code: "validation_failed",
            message: `Not a BCP-47 language code: ${JSON.stringify(value)}`,
            field: "language_code",
        });
    }
    return value;
}
/**
 * The 26 languages of product decision Q15b, as **data for fixtures and fakes** — not a type.
 *
 * PROVISIONAL. Q15b records the list as "provisional and needs one confirmation", and
 * design 14.5 U1 keeps "which 26 languages?" open. Nothing in this package branches on it;
 * it exists so a fake and a fixture can be written without inventing a different list.
 *
 * Sequencing is fixed even though the set is not: Greek, English and Hebrew ship first.
 */
export const PROVISIONAL_LAUNCH_LANGUAGE_CODE = [
    "el", // Greek   — ships first
    "en", // English — ships first
    "he", // Hebrew  — ships first
    "es",
    "fr",
    "de",
    "it",
    "pt",
    "nl",
    "sv",
    "da",
    "fi",
    "cs",
    "hu",
    "bg",
    "hr",
    "sk",
    "ro",
    "sl",
    "et",
    "lv",
    "lt",
    "tr",
    "ru",
    "uk",
    "ar",
];
/** The three languages with tested voices, bias and evaluation sets already proven. */
export const FIRST_LANGUAGE_CODE = ["el", "en", "he"];
//# sourceMappingURL=language-code.js.map